module.exports = __webpack_public_path__ + "static/media/thoughts4.3158635c.jpg";